import { render } from "./DetailArea.vue?vue&type=template&id=e71878fa"
import script from "./DetailArea.vue?vue&type=script&lang=js"
export * from "./DetailArea.vue?vue&type=script&lang=js"

import "./DetailArea.vue?vue&type=style&index=0&id=e71878fa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__